import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Button,
  Paper,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  InputBase
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Groups";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const allTeams = [
  {
    name: "Team Phoenix",
    description: "At the Cooperative Desk, we work together for project success.",
    color: "#D300C5"
  },
  {
    name: "Squad Alpha",
    description: "At the Collaboration Hub, we unite our efforts to achieve project excellence.",
    color: "#007BFF"
  },
  {
    name: "Division Omega",
    description: "At the Innovation Station, we harness creativity to drive project breakthroughs.",
    color: "#FFCC00"
  }
];

const TeamsSection = () => {
  const [teams, setTeams] = useState([allTeams[0]]);
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const isTeamAdded = (teamName) => teams.some((t) => t.name === teamName);

  const handleToggleTeam = (team) => {
    if (isTeamAdded(team.name)) {
      setTeams((prev) => prev.filter((t) => t.name !== team.name));
    } else {
      setTeams((prev) => [...prev, team]);
    }
  };

  const filteredTeams = allTeams.filter(
    (team) =>
      team.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      team.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Box> 
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
       <Typography
  variant="body2"
  sx={{
    color: teams.length === 0 ? '#64748B' : '#0076FE'
  }}
>
  TEAMS ({teams.length})
</Typography>

        <Button variant="outlined" onClick={() => setOpen(true)} 
          sx={{ 
                      borderRadius: '50px',
                      fontSize:'14px',
                      color: '#0076FE',
                      border: '1px solid #0076FE',
                      textTransform: 'none',
                      px: 2,
                      '&:hover': {
      backgroundColor: '#0076FE', // light blue hover background
      borderColor: '#0076FE',
      color:'#fff',    }
          }}
          >
          + Add Team
        </Button>
      </Box>

      <Stack spacing={2}>
        {teams.map((team, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 2
            }}
          >
            <Box display="flex" alignItems="center" gap={2}>
              <Avatar sx={{ bgcolor: team.color }}>
                <GroupIcon />
              </Avatar>
              <Box>
                <Typography sx={{fontSize:'14px', color:'#373737', }} fontWeight={500}>
                  {team.name}
                </Typography>
                <Typography variant="body2" sx={{fontSize:'12px', color:'#9095A1', }}>
                  {team.description}
                </Typography>
              </Box>
            </Box>
            <Button
              variant="outlined"
              color="inherit"
              size="small"
              sx={{
                 borderRadius: '50px',
                      color: '#595959',
                      border: '1px solid #595959',
              }}
              onClick={() => handleToggleTeam(team)}
            >
              Remove
            </Button>
          </Paper>
        ))}
      </Stack>

      {/* Add/Remove Team Modal */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth  PaperProps={{
    sx: {
      borderRadius: '16px',     // or '12px', etc.
      border: '4px solid #00AAE7'
    }
  }} >
     <Box sx={{ position: "relative", borderBottom:'1px solid #DFDFDF', pb:2, }}>
    <Typography sx={{ px: 3, pt:2, fontSize:'22px', color:'#1A1F36', fontWeight:'bold', }}>Add Team</Typography> 
    {/* Close IconButton */}
    <IconButton
      onClick={() => setOpen(false)}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500]
      }}
    >
      <CloseIcon />
    </IconButton> 
    {/* Subtitle */}
    <Typography variant="body2" color="text.secondary" px={3} mt={0.5}>
      Choose teams to include in your workspace.
    </Typography>
  </Box>

        {/* Search bar and count */}
        <Box px={3} py={1} display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              // border:'1px solid #DFDFDF',
              px: 1.5,
              py: 0.5,
              borderRadius: 20,
              flex: 1
            }}
          >
            <SearchIcon color="action" sx={{ mr: 1 }} />
            <InputBase
              placeholder="Search teams..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              fullWidth
              sx={{ fontSize: 14 }}
            />
          </Box>
          <Typography
  variant="body2"
  whiteSpace="nowrap"
  sx={{
    color: teams.length === 0 ? '#64748B' : '#0076FE'
  }}
>
  {teams.length} {teams.length === 1 ? "Team" : "Teams"} added
</Typography>

        </Box>

        <DialogContent
          dividers
          sx={{
            maxHeight: "550px",
            overflowY: "auto"
          }}
        >
          <Stack spacing={2}>
            {filteredTeams.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No teams found.
              </Typography>
            ) : (
              filteredTeams.map((team, index) => {
                const added = isTeamAdded(team.name);
                return (
                  <Paper
                    key={index}
                    elevation={0}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 2,
                      border: "1px solid #e0e0e0",
                      borderRadius: 2
                    }}
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ bgcolor: team.color }}>
                        <GroupIcon />
                      </Avatar>
                      <Box>
                        <Typography sx={{fontSize:'14px', color:'#373737', }} fontWeight={500}>
                          {team.name}
                        </Typography>
                        <Typography variant="body2" sx={{fontSize:'12px', color:'#9095A1', }}>
                          {team.description}
                        </Typography>
                      </Box>
                    </Box>
                   <Button 
                    size="small"
                    onClick={() => handleToggleTeam(team)}
                    sx={{
                      width:'80px',
                      borderRadius: '50px',
                      color: added ? '#595959' : '#0076FE',
                      border: `1px solid ${added ? '#595959' : '#0076FE'}`,
                      textTransform: 'none',
                      px: 2
                    }}
                  >
                    {added ? "Remove" : "Add"}
                  </Button>

                  </Paper>
                );
              })
            )}
          </Stack>
        </DialogContent> 
      </Dialog>
    </Box>
  );
};

export default TeamsSection;
